import React from 'react';
import * as ICONS from '../../../../images/react';

export type ValidIcon = keyof Omit<typeof ICONS, 'IIconProps'>;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: ValidIcon;
}

const Icon = ({ icon, ...rest }: IconProps) => {
  const IconComponent = ICONS[icon];

  return <IconComponent aria-hidden {...rest} />;
};

export default Icon;
